import { helpers } from '@vuelidate/validators';
export const cyrillic = helpers.regex(/^[а-яА-ЯёЁ]+$/);
export const phone = helpers.regex(/^(\+?\d{0,3})?\D?\(?(\d{3})\)?\D?(\d{3})\D?(\d{2})\D?(\d{2})$/);